import {useDialog} from "../../../hooks/useDialog";
import React, {useEffect, useState} from "react";
import {DynamicFields} from "../../../utils/dynamicFields";
import { AddFieldTemplateDialog } from "../../AddFieldTemplateDialog/AddFieldTemplateDialog";
import {getNumericId} from "../../../utils/uniqueIds";
import { DataGrid } from "@material-ui/data-grid";
import { Typography } from "@material-ui/core";
import {makeStyles} from "@material-ui/core";
import { FakeAddCheckListField } from "../../FakeAddCheckListField/FakeAddCheckListField";
import { AddDocumentTableConstructor } from "./AddDocumentTableConstructor";
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';
import IconButton from '@material-ui/core/IconButton';
import AddIcon from '@material-ui/icons/Add';
import DeleteIcon from '@material-ui/icons/Delete';
import { styled } from 'styled-components'
import Tooltip from '@material-ui/core/Tooltip';
import { getPropsColumn, getPropsRow } from "../../../utils/TableConstructorFiller";

const useStyles = makeStyles(() => ({
    addButton: {
        display: 'flex',
        alignItems: 'center',
    },
    table: {
        textAlign: 'center',
    },
    '.MuiDataGrid-cell': {
        
        textAlign: 'textCenter',
        justifyContent: 'center',
        alignItems: 'center'
    }
}))

const Block = styled.div`
    display: flex;
    align-items: center;
`
export const TableConstructorFieldFiller = ({content, setFieldValue}) => {

    const style = useStyles()

    const [column, setColumn] = useState(getPropsColumn(content.offenseWindow))
    const [row, setRow] = useState(getPropsRow(content.offenseWindow))

    const [loadRows, setLoadRows] = useState(content.adminRows ? content.adminRows : [])
    const [loadColumns, setLoadColumns] = useState(content.adminColumns ? content.adminColumns: null)

    const [errorColumn, setErrorColumn] = useState(false)
    const [successColumn, setSuccessColumn] = useState(false)

    const [selectionModel, setSelectionModel] = useState([])

    const {open, handleClose, handleOpen} = useDialog()
    const [selectedFieldTemplateIndex, setSelectedFieldTemplateIndex] = useState(null)

    const offenseWindow = content?.offenseWindow || []
    const tableConfig = content?.tableConfig || {columns: []}


    const handleRowChange = (params) => {
        let getRows = [...loadRows]
        let newRows = []
        getRows.map(row => {
                if (row.id === params.id) {
                    let newRow = row
                    newRow[params.field] = params.value
                    newRows.push(newRow)
                } else newRows.push(row)
        })
        setLoadRows(newRows)
        setFieldValue('content.adminRows', newRows)
    }

    const handleFieldTemplateDelete = (deletedField, newFields) => {
        setFieldValue('content', {
            ...content,
            offenseWindow: newFields,
            filesVariable: DynamicFields.DRAG_AND_DROP_FILES_UPLOAD === deletedField.type ? '' : content?.filesVariable,
            normativeArticleVariable: deletedField.type === DynamicFields.NORMATIVE_ARTICLES_TABLE
            || deletedField.type === DynamicFields.NORMATIVE_ARTICLE_SELECT ? '' : content?.normativeArticleVariable,
            tableConfig: {
                ...tableConfig,
                columns: tableConfig?.columns?.filter(f => f.field !== deletedField.variable)
            }
        })
    }

    const handleSequenceNumberChange = newFields => {
        setFieldValue('content.offenseWindow', newFields)
    }

    const handleFieldTemplateClick = index => {
        setSelectedFieldTemplateIndex(index)
        handleOpen()
    }

    const handleAddFieldTemplate = fieldTemplate => {
        setFieldValue('content', {
            ...content,
            offenseWindow: [...offenseWindow, {
                ...fieldTemplate,
                id: getNumericId(),
                sequenceNumber: offenseWindow.length + 1
            }],
            filesVariable: fieldTemplate.type === DynamicFields.DRAG_AND_DROP_FILES_UPLOAD ?
                fieldTemplate.variable : content?.filesVariable,
            normativeArticleVariable: fieldTemplate.type === DynamicFields.NORMATIVE_ARTICLES_TABLE ||
            fieldTemplate.type === DynamicFields.NORMATIVE_ARTICLE_SELECT ?
                fieldTemplate.variable : content?.normativeArticleVariable
        })
        const col = [{
            field: fieldTemplate.label,
            headerName: fieldTemplate.label,
            width: 140,
            editable: true,
        }]
        let newColumns = [...column, ...col]
        setColumn(newColumns)
        let stokeForRow = {
            [fieldTemplate.label]: fieldTemplate.type,
        }
        const rowObj = row[0]
        let newRow = {...rowObj, ...stokeForRow}
        setRow([newRow])
        handleClose()
        setSelectedFieldTemplateIndex(null)
    }

    const handleDeleteLast = () => {
        let newContent = [...content.offenseWindow]
        let head = [...content.adminHead]
        let admin = [...content.adminColumns]
        const lastone = newContent.pop()
        head.pop()
        admin.pop()

        setFieldValue('content', {
            ...content,
            offenseWindow: newContent,
            adminHead: head,
            adminColumns: admin,
        })
        let deleteColomn = [...column]
        deleteColomn.pop()

        setColumn(deleteColomn)

        let newColumn = [...loadColumns]
        newColumn.pop()
        setLoadColumns(newColumn)
        
        setLoadRows((prev) => {
            return prev.map((row) => {
                delete row[lastone.variable]
                return row
            })
        })
    }

    const handleMutateOffense = (params) => {
        if (params.field !== 'id') {
            let newOffenseWindow = [...offenseWindow]
            newOffenseWindow.map((el, index) => {
                if (params.field === el.label) {
                    setSelectedFieldTemplateIndex(index)
                }
            })
            handleOpen()
        }
    }

    const handleFieldTemplateChange = fieldTemplate => {
        setFieldValue('content', {
            ...content,
            offenseWindow: offenseWindow.map((el, i) => {
                if (i === selectedFieldTemplateIndex) {
                    return fieldTemplate
                }
                return el
            }),
            filesVariable: fieldTemplate.type === DynamicFields.DRAG_AND_DROP_FILES_UPLOAD ?
                fieldTemplate.variable : content?.filesVariable,
            normativeArticleVariable: fieldTemplate.type === DynamicFields.NORMATIVE_ARTICLES_TABLE ||
            fieldTemplate.type === DynamicFields.NORMATIVE_ARTICLE_SELECT ?
                fieldTemplate.variable : content?.normativeArticleVariable
        })
        const fakeColumn = [...column]
        let newColumn = [...column]
        fakeColumn.map((el, index) => {
            if (index === fieldTemplate.sequenceNumber) {
                newColumn[index] = {
                    field: fieldTemplate.label,
                    headerName: fieldTemplate.label,
                    width: 140,
                    editable: true,
                }
            }
        })
        let newRow = {}
        const fakeRow = [...row]
        const fakeRowObj = fakeRow[0]
        let i = 0
        for (const key in fakeRowObj) {
            if (i === fieldTemplate.sequenceNumber) {
                let newPeremen = {
                    [fieldTemplate.label]: fieldTemplate.type
                }
                newRow = {...newRow, ...newPeremen}
            } else { newRow = {...newRow, ...{ [key]: fakeRowObj[key]}}}
            i++
        }
        setColumn(newColumn)
        setRow([newRow])
        handleClose()
        setSelectedFieldTemplateIndex(null)
    }

    const handleCloseChange = () => {
        setSelectedFieldTemplateIndex(null)
        handleClose()
    }

    const handleCloseErrorColumn = () => {
        setErrorColumn(false)
    }

    const handleCloseSuccessColumn = () => {
        setSuccessColumn(false)
    }

    const deleteRow = () => {
        setLoadRows((prev) => {
            const filter = prev.filter((row) => !selectionModel.includes(row.id)).map((row, id) => {
                row.id = id + 1
                return row
            })
            setFieldValue('content.adminRows', filter)
            setSelectionModel([])
            return filter
        })
    }

    const addEmptyRow = () => {
        if (loadRows.length > 0) {
            setLoadRows((prev) => {
                const row = prev[prev.length - 1];
                let cleanRow = {}
                for(let [key, value] of Object.entries(row)) {
                    if (key === 'id') {
                        cleanRow = {
                            ...cleanRow,
                            id: prev.length + 1,
                        } 
                    } else {
                    cleanRow = {
                            ...cleanRow,
                            [key]: '',
                        } 
                    } 
                }
                setFieldValue('content.adminRows', [...prev, ...[cleanRow]])
                return [...prev, ...[cleanRow]]
            }) 
        }
        
    }

    const CustomToolbar = () => {
        return(
            <Block>
                <Tooltip    
                    title="Добавить строку"
                >   
                    <IconButton
                        onClick={addEmptyRow}
                    >
                        <AddIcon />
                    </IconButton> 
                </Tooltip>
                <Tooltip    
                    title="Удалить строку"
                >   
                    <IconButton
                        onClick={deleteRow}
                    >
                        <DeleteIcon />
                    </IconButton>
                </Tooltip>
            </Block>
        )
    }

    const AddCheckListField = () => {
        return(
            <div className={style.addButton}>
                <FakeAddCheckListField 
                        fakeFields={offenseWindow}
                        handleAddButtonClick={handleOpen}
                        handleDeleteLast={handleDeleteLast}
                        handleFieldTemplateDelete={handleFieldTemplateDelete}
                        handleSequenceNumberChange={handleSequenceNumberChange}
                        handleFieldTemplateClick={handleFieldTemplateClick}
                />
            </div>
        );
    }

    function Alert(props) {
        return <MuiAlert elevation={6} variant="filled" {...props} />;
    }

    return (
        <React.Fragment>
            <div style={{marginTop: '20px', display: 'flex', flexWrap: 'wrap', rowGap: '10px'}}>
                <Typography variant="h6">Столбцы</Typography>
            </div>
            <div style={{ height: 300, width: '100%' }}>
                <DataGrid
                    rows={row}
                    columns={column}
                    components={{
                        Toolbar: AddCheckListField,
                        }}
                    pageSize={[2]}
                    editRowsModel
                    disableSelectionOnClick={true}
                    disableColumnFilter={true}
                    disableColumnMenu={true}
                    disableColumnSelector={true}
                    disableDensitySelector={true}
                    disableVirtualization={true}
                    onCellClick={handleMutateOffense}
                />
            </div>

            <div style={{marginTop: '20px', display: 'flex', flexWrap: 'wrap', rowGap: '10px'}}>
                <Typography variant="h6">Данные</Typography>
            </div>
            <div style={{ height: 600, width: '100%' }}>
                <DataGrid 
                    rows={loadRows ?? []}
                    components={{
                        Toolbar: CustomToolbar,
                        }}
                    columns={loadColumns ?? []}
                    pageSize={[25]}
                    onCellEditCommit={handleRowChange}
                    onSelectionModelChange={(ids) => {
                        setSelectionModel(ids);
                      }}
                    checkboxSelection
                    disableSelectionOnClick
                />
            </div>    
            <AddFieldTemplateDialog open={open}
                                    handleClose={handleCloseChange}
                                    handleSave={handleAddFieldTemplate}
                                    handleFieldTemplateChange={handleFieldTemplateChange}
                                    selectedFieldTemplate={selectedFieldTemplateIndex !== null ?
                                        offenseWindow[selectedFieldTemplateIndex] : null}
            />
            <AddDocumentTableConstructor 
                setValues={setLoadRows} 
                setColumns={setLoadColumns}
                setFieldValue={setFieldValue} 
                content={content}
                offenseWindow={offenseWindow}
                setErrorColumn={setErrorColumn}
                setSuccessColumn={setSuccessColumn}
            />
            <Snackbar open={errorColumn} autoHideDuration={6000} onClose={handleCloseErrorColumn}>
                <Alert onClose={handleCloseErrorColumn} severity="error">
                    Количество колонок таблицы не совпадает!!!
                </Alert>
            </Snackbar>
            <Snackbar open={successColumn} autoHideDuration={6000} onClose={handleCloseSuccessColumn}>
                <Alert onClose={handleCloseSuccessColumn} severity="success">
                    Файл успешно загружен
                </Alert>
            </Snackbar>
        </React.Fragment>
    )
}